<script setup>

</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 12H12" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 12H2" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 9.33337H12" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 9.33337H2" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 6.66663H12" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 6.66663H2" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 4H12" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 4H2" stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
      d="M11.3333 2H4.66667C4.29848 2 4 2.29848 4 2.66667V13.3333C4 13.7015 4.29848 14 4.66667 14H11.3333C11.7015 14 12 13.7015 12 13.3333V2.66667C12 2.29848 11.7015 2 11.3333 2Z"
      stroke="#B5CB09" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped>

</style>
